export const bootStrapGrid = { sm: 768, md: 992, lg: 1200 };
